// Source unique de configuration produit — utilisée partout (UI, SEO, e-mails côté front).
// Le jour du domaine/nom définitif : ne changer que frontend/.env, puis relancer scripts/gen_seo.py.
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME || "Pulse";
export const PRODUCT_URL = process.env.REACT_APP_PRODUCT_URL || "https://gilles-editorial-ai.preview.emergentagent.com";
export const PRODUCT_TAGLINE = process.env.REACT_APP_PRODUCT_TAGLINE || "Vos posts LinkedIn, dans votre style";
export const COMPANY = "APOLLO";
